import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { map, Observable } from 'rxjs';
import { AfRoutes } from '../../routes';

export function mfaGuard(): CanMatchFn {
  return (): Observable<boolean | UrlTree> => {
    const authenticationService: AuthenticationService = inject(
      AuthenticationService
    );
    const router: Router = inject(Router);

    return authenticationService.needsMfaSetup().pipe(
      map((needsMfaSetup) =>
        needsMfaSetup ? router.createUrlTree([AfRoutes.setupTotpMfa]) : true
      )
    );
  };
}
